import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'errorReport',
    serviceName: 'shopadmin',
    query: gql`
      query errorReport($ids: [String]) {
        errorReport(ids: $ids) {
          data {
            id
            status
            done_date
            description
            product_name
            product_brand
            product_details
            product_category
            product_image
            product_image_quality
            product_unit
            product_booth
            max_number_buy
            min_number_buy
            location
            description
            created_at
            updated_at
            shop {
              id
            }
            product {
              id
            }
            product_shop {
              id
              product_info {
                id
                title
                barcode
                media {
                  full_url
                }
              }
            }
            creator {
              id
              firstname
              lastname
            }
            done_by {
              id
            }
          }
          total
          per_page
          current_page
          from
          to
          last_page
          has_more_pages
        }
      }
    `,
  },
  update: {
    name: 'updateErrorReport',
    serviceName: 'shopadmin',
    query: gql`
      mutation updateErrorReport(
        $ids: [String]!
        $status: String
        $product_name: String
        $product_brand: String
        $product_details: String
        $product_category: String
        $product_image: String
        $product_image_quality: String
        $product_unit: String
        $product_booth: String
        $max_number_buy: String
        $min_number_buy: String
        $description: String
      ) {
        updateErrorReport(
          ids: $ids
          status: $status
          product_name: $product_name
          product_brand: $product_brand
          product_details: $product_details
          product_category: $product_category
          product_image: $product_image
          product_image_quality: $product_image_quality
          product_unit: $product_unit
          product_booth: $product_booth
          max_number_buy: $max_number_buy
          min_number_buy: $min_number_buy
          description: $description
        ) {
          model {
            id
          }
          messages
          influenced_count
        }
      }
    `,
  },
};

export default schema;
